"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var __1 = require("..");
var FeatureFlag = function (_a) {
    var name = _a.name, _b = _a.defaultValue, defaultValue = _b === void 0 ? false : _b, _c = _a.invert, invert = _c === void 0 ? false : _c, children = _a.children;
    var flagsClient = react_1.useContext(__1.FlagsContext);
    var flag = flagsClient ? flagsClient.getFlag(name) : undefined;
    var isEnabled = defaultValue;
    if (flag !== undefined) {
        isEnabled = invert ? !flag.enabled : flag.enabled;
    }
    return (react_1.default.createElement(react_1.Fragment, null, typeof children === 'function' ? children(flag) : isEnabled ? children : null));
};
exports.default = FeatureFlag;
//# sourceMappingURL=FeatureFlag.js.map